import React, { useState } from "react";

const InvestorsPopup = ({ names, onClose }) => {
  const [search, setSearch] = useState("");
  const filtered = search.trim()
    ? names.filter((n) => n.toLowerCase().includes(search.toLowerCase()))
    : names;

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1300, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ backgroundColor: "#fff", borderRadius: "10px", boxShadow: "0 8px 32px rgba(0,0,0,0.18)", width: "380px", maxHeight: "480px", display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ padding: "16px 20px", borderBottom: "1px solid #E5E7EB", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h4 style={{ margin: 0, color: "#1C1D4D", fontSize: "1rem" }}>Other Investors</h4>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "1.2rem", color: "#6B7280" }}>✕</button>
        </div>
        <div style={{ padding: "12px 20px", borderBottom: "1px solid #F3F4F6" }}>
          <input
            className="form__input form__input--search"
            type="text"
            placeholder="Search investors…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: "100%", fontSize: "0.875rem" }}
            autoFocus
          />
        </div>
        <div style={{ overflowY: "auto", flex: 1, padding: "8px 0" }}>
          {filtered.length === 0 ? (
            <p style={{ padding: "16px 20px", color: "#6B7280", fontSize: "0.875rem" }}>No investors found.</p>
          ) : filtered.map((name, i) => (
            <div key={i} style={{ padding: "10px 20px", fontSize: "0.875rem", color: "#1C1E4D", borderBottom: "1px solid #F9FAFB" }}>
              {name}
            </div>
          ))}
        </div>
      </div>
      <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.4)", zIndex: -1 }} onClick={onClose} />
    </div>
  );
};

const GenericTable = ({ columns, data = [], onRowClick }) => {
  const [popup, setPopup] = useState(null); // array of all investor names for the open row
  const noData = !data || data.length === 0;

  return (
    <>
      <div className="tableContainer">
        <table className="table">
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>
                  <div className="sortingDiv">{col.header}</div>
                </th>
              ))}
            </tr>
          </thead>

          {noData ? (
            <tbody>
              <tr>
                <td colSpan={columns.length}>
                  <div className="nodata">No Accounts Found</div>
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => {
                    if (col.key === "investors" || col.key === "financialAdvisor") {
                      const all     = row[col.key] || [];
                      const visible  = all.slice(0, 3);
                      const overflow = all.length - visible.length;

                      return (
                        <td key={colIndex}>
                          <div className="cellText cellText--investors">
                            {visible.map((name, i) => (
                              <span key={i} className="investorBtn">{name}</span>
                            ))}

                            {overflow > 0 && (
                              <span
                                className="investorBtn"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => { e.stopPropagation(); setPopup(all); }}
                              >
                                +{overflow}
                                <AccountArrowDown />
                              </span>
                            )}
                          </div>
                        </td>
                      );
                    }

                    if (col.key === "accountName" && onRowClick) {
                      return (
                        <td key={colIndex}>
                          <div className="cellText">
                            <span
                              className="cellText__primary cellText__primary--link"
                              style={{ cursor: "pointer", color: "#1C1D4D", textDecoration: "underline" }}
                              onClick={() => onRowClick(row)}
                            >
                              {row[col.key]}
                            </span>
                          </div>
                        </td>
                      );
                    }

                    return (
                      <td key={colIndex}>
                        <div className="cellText">
                          <span className="cellText__primary">{row[col.key]}</span>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>

      {popup && (
        <InvestorsPopup names={popup} onClose={() => setPopup(null)} />
      )}
    </>
  );
};

// Keep the SVG inline to remove the Ant Design Dropdown dependency
const AccountArrowDown = () => (
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" style={{ marginLeft: "4px" }}>
    <path d="M1 1l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default GenericTable;
